<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>{{ title }}</h2>
    </header>
    <div class="p-0 p-md-4">
      <div class="row">
        <div class="col-12 col-lg-6">
          <h3 class="mt-3 mb-5">Files & Documents Download</h3>
          <div class="">
            <a
              v-for="(document, k) in documents"
              :key="document"
              :href="backendURL + '/files/uploads/' + k"
              class="
                w3-block
                size16
                w3-border
                my-3
                py-2
                px-4
                w3-text-black w3-hover-red w3-hover-text-white
                no-hover-underline
              "
              target="_blank"
              ><i class="bx bxs-file-archive"></i> {{ document }}
            </a>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>
  </section>
</template> 
<script>
import { ref, onBeforeMount, computed } from "vue";
import { useStore } from "vuex";
import { backendURL } from "@/helpers/utilities";
export default {
  components: {},

  setup() {
    const title = ref("Documents Download");
    const store = useStore();
    const SETTINGS = computed(() => store.state.appSettings);
    const documents = SETTINGS.value._DOCUMENT_DOWNLOADS;
    onBeforeMount(() => {
      store.dispatch("resetIdleTime");
    });
    return {
      title,
      documents,
      backendURL,
    };
  },
};
</script>
